import { Customer, Estimate, Invoice } from '@biz-nest/commerce-client';
import { FrontendLogger } from '@biz-nest/core-client';

export const dashCardsBmUse = (companyId: string) => {
  const getAmountDueCount = async() => {
    try {
      const res = await Customer.analytics({
        propFilter: {
          company: companyId
        },
        comparisonFilter: [{
          field: 'amountDue.value',
          fieldValue: 0,
          operator: 'gt'
        }],
        returnEmptyArray: true
      });

      FrontendLogger.debug('getAmountDueCount', res);

      return res.amountDue;
    } catch (err) {
      FrontendLogger.error(err);

      return 0;
    }
  };

  const getCustomers = async() => {
    try {
      const { count } = await Customer.filterAll({
        propFilter: {
          company: companyId
        },
        returnEmptyArray: true
      });

      return count;
    } catch (err) {
      FrontendLogger.error(err);

      return 0;
    }
  };

  const getAllInvoicesTotal = async() => {
    const res = await getAnalyticsRelegator({});

    return res.count;
  };

  const getAnalyticsRelegator = async(filter) => {
    if (!filter) {
      filter = {};
    }
    filter.propFilter = {
      ...filter.propFilter,
      company: companyId
    };

    try {
      const { totalAmount, count } = await Invoice.getInvoiceAnalytics(filter);

      return { totalAmount, count };
    } catch (err) {
      FrontendLogger.error(err);

      return { totalAmount: 0, count: 0 };
    }
  };

  const getUnpaidInvoicesCount = async() => {
    const res = await getAnalyticsRelegator({ propFilter: { status: 'unpaid' } });

    return res.count;
  };

  const getOverdueInvoicesCount = async() => {
    const res = await getAnalyticsRelegator({ propFilter: { status: 'overdue' } });

    return res.count;
  };

  const getEstimatesCount = async() => {
    try {
      const { count } = await Estimate.filterAll({ returnEmptyArray: true });

      return count;
    } catch (err) {
      FrontendLogger.error('get Error, ', err);

      return 0;
    }
  };

  const monthlyEvaluationCustomers = async() => {
    try {
      const now = new Date();
      const last = new Date(new Date().setMonth(now.getMonth() - 1));
      const nowMonth = await Customer.filterAll({
        propFilter: {
          company: companyId
        },
        returnEmptyArray: true,
        comparisonFilter: [{
          field: 'createdAt',
          fieldValue: new Date(now.getFullYear(), now.getMonth() + 1, 0),
          operator: 'lte'
        },
        {
          field: 'createdAt',
          fieldValue: new Date(now.getFullYear(), now.getMonth(), 1),
          operator: 'gte'
        }]
      });

      const lastMonth = await Customer.filterAll({
        propFilter: {
          company: companyId
        },
        returnEmptyArray: true,
        comparisonFilter: [{
          field: 'createdAt',
          fieldValue: new Date(last.getFullYear(), last.getMonth() + 1, 0),
          operator: 'lte'
        }, {
          field: 'createdAt',
          fieldValue: new Date(last.getFullYear(), last.getMonth(), 1),
          operator: 'gte'
        }]
      });

      const customerIncreDecre = Math
        .round(((nowMonth.count - lastMonth.count) / 100) * (nowMonth.count + lastMonth.count) * 1000) / 1000;
      const customerIncreDecreStyle = `width: ${customerIncreDecre}%`;

      return {
        customerIncreDecre,
        customerIncreDecreStyle
      };
    } catch (error) {
      FrontendLogger.error('DashCardsBmForSharedUse:monthlyEvaluationCustomers:: - err ', error);

      return {
        customerIncreDecre: 0,
        customerIncreDecreStyle: 'width: 0%'
      };
    }
  };


  const monthlyEvaluationInvoices = async() => {
    try {
      const now = new Date();
      const last = new Date(new Date().setMonth(now.getMonth() - 1));
      const nowMonth = await Invoice.filterAll({
        propFilter: {
          company: companyId
        },
        returnEmptyArray: true,
        comparisonFilter: [{
          field: 'createdAt',
          fieldValue: new Date(now.getFullYear(), now.getMonth() + 1, 0),
          operator: 'lte'
        },
        {
          field: 'createdAt',
          fieldValue: new Date(now.getFullYear(), now.getMonth(), 1),
          operator: 'gte'
        }]
      });

      const lastMonth = await Invoice.filterAll({
        propFilter: {
          company: companyId
        },
        returnEmptyArray: true,
        comparisonFilter: [{
          field: 'createdAt',
          fieldValue: new Date(last.getFullYear(), last.getMonth() + 1, 0),
          operator: 'lte'
        }, {
          field: 'createdAt',
          fieldValue: new Date(last.getFullYear(), last.getMonth(), 1),
          operator: 'gte'
        }]
      });

      const invoiceIncreDecre = Math
        .round(((nowMonth.count - lastMonth.count) / 100) * (nowMonth.count + lastMonth.count) * 1000) / 1000;
      const invoiceIncreDecreStyle = `width: ${invoiceIncreDecre}%`;

      return {
        invoiceIncreDecre,
        invoiceIncreDecreStyle
      };
    } catch (error) {
      FrontendLogger.error('DashCardsBmForSharedUse:monthlyEvaluationInvoices:: - err ', error);

      return {
        invoiceIncreDecre: 0,
        invoiceIncreDecreStyle: 'width: 0%'
      };
    }
  };

  const monthlyEvaluationEstimates = async() => {
    try {
      const now = new Date();
      const last = new Date(new Date().setMonth(now.getMonth() - 1));
      const nowMonth = await Invoice.filterAll({
        propFilter: {
          company: companyId
        },
        returnEmptyArray: true,
        comparisonFilter: [{
          field: 'createdAt',
          fieldValue: new Date(now.getFullYear(), now.getMonth() + 1, 0),
          operator: 'lte'
        },
        {
          field: 'createdAt',
          fieldValue: new Date(now.getFullYear(), now.getMonth(), 1),
          operator: 'gte'
        }]
      });

      const lastMonth = await Estimate.filterAll({
        propFilter: {
          company: companyId
        },
        returnEmptyArray: true,
        comparisonFilter: [{
          field: 'createdAt',
          fieldValue: new Date(last.getFullYear(), last.getMonth() + 1, 0),
          operator: 'lte'
        }, {
          field: 'createdAt',
          fieldValue: new Date(last.getFullYear(), last.getMonth(), 1),
          operator: 'gte'
        }]
      });

      const estimateIncreDecre = Math
        .round(((nowMonth.count - lastMonth.count) / 100) * (nowMonth.count + lastMonth.count) * 1000) / 1000;
      const estimateIncreDecreStyle = `width: ${estimateIncreDecre}%`;

      return {
        estimateIncreDecre,
        estimateIncreDecreStyle
      };
    } catch (error) {
      FrontendLogger.error('DashCardsBmForSharedUse:monthlyEvaluationEstimates:: - err ', error);

      return {
        estimateIncreDecre: 0,
        estimateIncreDecreStyle: 'width: 0%'
      };
    }
  };

  return {
    getAmountDueCount,
    getCustomers,
    getAllInvoicesTotal,
    getUnpaidInvoicesCount,
    getOverdueInvoicesCount,
    getEstimatesCount,
    monthlyEvaluationCustomers,
    monthlyEvaluationInvoices,
    monthlyEvaluationEstimates
  };
};
